var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0575 7.70463C4.00917 7.65943 3.8025 7.48875 3.6325 7.32976C2.56333 6.39766 0.813333 3.9661 0.279167 2.69342C0.193333 2.50015 0.0116667 2.0115 0 1.75041C0 1.50024 0.06 1.26176 0.181667 1.03419C0.351667 0.750511 0.619167 0.522942 0.935 0.398246C1.15417 0.317974 1.81 0.193278 1.82167 0.193278C2.53917 0.0685826 3.705 0 4.99333 0C6.22083 0 7.33917 0.0685826 8.0675 0.170677C8.07917 0.182367 8.89417 0.307063 9.17333 0.443449C9.68333 0.693619 10 1.18227 10 1.70521V1.75041C9.9875 2.09099 9.67083 2.80721 9.65917 2.80721C9.12417 4.0113 7.46 6.38675 6.35417 7.34145C6.35417 7.34145 6.07 7.61033 5.8925 7.72723C5.6375 7.9096 5.32167 8 5.00583 8C4.65333 8 4.325 7.89791 4.0575 7.70463Z",
    fill: "#5F5577"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.6697f601.svg";
export { ForwardRef as ReactComponent };